/*
 * @Author: lsqbeyond lsqbeyond@yeah.net
 * @Date: 2025-09-02 21:28:25
 * @LastEditors: lsqbeyond lsqbeyond@yeah.net
 * @LastEditTime: 2025-10-15 00:41:15
 * @FilePath: \tracenew\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import Overview from '@/views/Overview'
import HomePage from '@/views/HomePage'
import News from '@/views/News'
import HangYeNews from '@/views/HangYeNews'
import HuiKuiNews from '@/views/HuiKuiNews'
import XiaoQiNews from '@/views/XiaoQiNews'
import Team from '@/views/Team'
import TeamUserDetail from '@/views/teamUserDetail'
import PracticeAreas from '@/views/PracticeAreas'
import ExpertiseAreas from '@/views/ExpertiseAreas'
import Contact from '@/views/Contact'
import i18n from '../i18n'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // 浏览器前进/后退时，恢复到离开前的位置
    if (savedPosition) {
      return savedPosition
    }
    // 同一路径仅变更 query/hash 时不滚动，保留当前位置
    if (to.path === from.path && !to.hash) {
      return false
    }
    // 如果包含 hash，滚动到对应锚点
    if (to.hash) {
      return { selector: to.hash }
    }
    // 不同页面时滚动到顶部
    return { x: 0, y: 0 }
  },
  routes: [
    // 默认路由重定向到中文
    {
      path: '/',
      redirect: to => {
        return `/${i18n.locale}${to.path === '/' ? '' : to.path}`
      }
    },
    // 带语言前缀的路由
    {
      path: '/:lang(zh|en|de)',
      component: {
        render: h => h('router-view')
      },
      beforeEnter(to, from, next) {
        const lang = to.params.lang
        if (!['zh', 'en', 'de'].includes(lang)) {
          return next('/zh')
        }
        if (i18n.locale !== lang) {
          i18n.locale = lang
        }
        next()
      },
      children: [
        {
          path: '',
          name: 'Overview',
          component: Overview
        },
        {
          path: 'company-intro',
          name: 'HomePage',
          component: HomePage
        },
        {
          path: 'news',
          name: 'News',
          component: News
        },
        {
          path: 'hangye-news',
          name: 'HangYeNews',
          component: HangYeNews
        },
        {
          path: 'huikui-news',
          name: 'HuiKuiNews',
          component: HuiKuiNews
        },
        {
          path: 'xiaoqi-news',
          name: 'XiaoQiNews',
          component: XiaoQiNews
        },
        {
          path: 'team',
          name: 'Team',
          component: Team
        },
        {
          path: 'practice-areas',
          name: 'PracticeAreas',
          component: PracticeAreas
        },
        {
          path: 'expertise-areas',
          name: 'ExpertiseAreas',
          component: ExpertiseAreas
        },
        {
          path: 'contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: 'team-user-detail',
          name: 'TeamUserDetail',
          component: TeamUserDetail
        }
      ]
    },
    // 兼容旧路由，重定向到带语言前缀的路由
    {
      path: '/company-intro',
      redirect: '/zh/company-intro'
    },
    {
      path: '/team',
      redirect: '/zh/team'
    },
    {
      path: '/practice-areas',
      redirect: '/zh/practice-areas'
    },
    {
      path: '/expertise-areas',
      redirect: '/zh/expertise-areas'
    },
    {
      path: '/news',
      redirect: '/zh/news'
    },
    {
      path: '/hangye-news',
      redirect: '/zh/hangye-news'
    },
    {
      path: '/huikui-news',
      redirect: '/zh/huikui-news'
    },
    {
      path: '/xiaoqi-news',
      redirect: '/zh/xiaoqi-news'
    },
    {
      path: '/contact',
      redirect: '/zh/contact'
    },
    {
      path: '/team-user-detail',
      redirect: '/zh/team-user-detail'
    },
    // 默认路由重定向到首页
    {
      path: '*',
      redirect: '/zh'
    }
  ]
})

export default router